module.exports = __webpack_public_path__ + "media/src/images/user/default_profile_photo-360fa4657fb1a21a64081b867df4ce83.png";